import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/mitt-avtal")({
  head: () => seoHead("/mitt-avtal"),
  beforeLoad: () => permanentRedirect("/mitt-elpris"),
});
